import React, { useState } from "react"
import { graphql } from "gatsby"
import { useLocale } from "src/common/hooks"

import { getNodeByLocale } from "src/common/getNodesByLocale"
import { useHeaderColor } from "src/common/hooks"
import Layout from "src/layout"

import Banner from "../components/Banner"
import Partners from "./components/Partners"
import Features from "../components/Features"
import UseCases from "../components/UseCases"
import AzureNote from "../components/AzureNote"
import KeyPoints from "../components/KeyPoints"
import ContactSalesModal from "src/developers/ContactSales"
import {
  CONTACT_MODAL,
  DOWNLOAD_ASSET_MODAL,
  getModalClickHandler,
} from "../../../components/ModalsContainer/events"

const BusinessTypePage = ({ data, location }) => {
  const locale = useLocale()

  const locales = getNodeByLocale(
    data.allContentfulSolutionsBusinessTypePage.nodes.filter(
      ({ keyPoints2 }) => !!keyPoints2
    ),
    locale
  )

  const { inverse, isChangeColor } = useHeaderColor({
    defaultInverse: true,
    elem: { selector: "#content", inverse: false },
  })

  const headerColor = {
    primaryColor:
      "linear-gradient(255.03deg, #7785FF -0.91%, #6472EF 102.89%) #fff",
    secondaryColor: "#fff",
  }

  const [isContactSalesModalOpen, setIsContactSalesModalOpen] = useState(false)
  const handleModalClose = () => setIsContactSalesModalOpen(false)
  const handleModalOpen = () => setIsContactSalesModalOpen(true)

  const handleCtaClick = locales.ctaDownloadAssetModal
    ? getModalClickHandler(DOWNLOAD_ASSET_MODAL, {
        modalId: locales.ctaDownloadAssetModal.modalId,
      })
    : getModalClickHandler(CONTACT_MODAL)

  return (
    <Layout
      location={location}
      headerColor={headerColor}
      headerInverse={inverse}
      headerIsChangeColor={isChangeColor}
      openModal={handleModalOpen}
    >
      <Banner
        json={locales.solutionKeyPointsMainBody.json}
        image={locales.mainImage}
        ctaBtnName={locales.ctaButtonName}
        onCtaClick={handleCtaClick}
      />
      <Partners logos={locales.logos} />
      <Features
        inverseOrder
        json={locales.featuresBlock.json}
        onCtaClick={handleCtaClick}
        ctaBtnName={locales.featuresCtaButtonName}
      />
      <UseCases title={locales.heading2} json={locales.keyPoints2.json} />
      <AzureNote json={locales.solutionHighlightedNote.json} />
      <KeyPoints
        title={locales.heading3}
        json={locales.mainBody3.json}
        btnName={locales.cta3}
        btnUrl={locales.cta3Url}
        btnModalType={locales.cta3ModalType}
        btnModalTitle={locales.cta3ModalTitle}
      />
      <ContactSalesModal
        content={{ title: "Contact Sales" }}
        isOpen={isContactSalesModalOpen}
        onClose={handleModalClose}
      />
    </Layout>
  )
}

export default BusinessTypePage

export const query = graphql`
  query($slug: String!) {
    allContentfulSolutionsBusinessTypePage(filter: { pageId: { eq: $slug } }) {
      nodes {
        pageId
        node_locale
        logos {
          id
          file {
            url
          }
          description
        }
        cta3
        cta3Url
        cta3ModalType
        cta3ModalTitle
        ctaButtonName
        ctaDownloadAssetModal {
          modalId
        }
        featuresBlock {
          json
        }
        featuresCtaButtonName
        heading2
        heading3
        keyPoints2 {
          json
        }
        mainBody3 {
          json
        }
        mainImage {
          file {
            url
          }
          description
        }
        solutionHighlightedNote {
          json
        }
        solutionKeyPointsMainBody {
          json
        }
      }
    }
  }
`